// extracted by mini-css-extract-plugin
export default {"loader":"MagicTextLoader_loader__JWTE4","gradient-shift":"MagicTextLoader_gradient-shift__amy+L"};